module.exports = __webpack_public_path__ + "static/DonaAlt-Medium-e5b7d289917bc4a52239c5355a7ed874.woff2";